import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../Layout/AppMain/PageTitle";
import Loader from "react-loaders";
import { api, userService } from "../../_services";
import {
  Button,
  Card,
  CardBody,
  Row,
  Col,
  CustomInput,
  Input,
  Label,
} from "reactstrap";
import Moment from "react-moment";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import DatePicker from "react-datepicker";
import ExpenseModal from "../Invoice/InvoiceSettings/Components/ExpenseModal";
import { currencyFormatter } from "../../_services/currencyFormatter";

const ExpenseList = (props) => {
  const currentUser = userService.getLoggedInUser();
  const [isLoading, setIsLoading] = useState(false);
  const [expenses, setExpenses] = useState([]);
  const [partnershipList, setPartnershipList] = useState([]);
  const [selectedPartnershipId, setSelectedPartnershipId] = useState(-1);
  const [startDate, setStartDate] = useState(
    moment().subtract(1, "month").startOf("day").toDate(),
  );
  const [endDate, setEndDate] = useState(moment().endOf("day").toDate());
  const [selectedVendorId, setSelectedVendorId] = useState(-1);
  const [expenseToEdit, setExpenseToEdit] = useState(null);
  const [showExpenseModal, setShowExpenseModal] = useState(false);
  const [vendors, setVendors] = useState([]);

  const newExpense = {
    expenseId: -1,
    invoiceId: 0,
    matterId: -1,
    matterName: "Not selected",
    expenseName: "",
    notes: "",
    expenseAmount: "",
    currencyId: 3,
    expenseDate: new Date(),
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (partnershipList.length > 0) {
      loadExpenses();
    }
  }, [selectedPartnershipId]);

  const loadExpenses = () => {
    api.getExpenseListByPartnershipIds(getPartnershipIds()).then((e) => {
      setExpenses(e);
    });
  };

  const loadData = async () => {
    setIsLoading(true);

    try {
      let p = await api.getPartnershipListByEntityId(
        currentUser.entityId,
        currentUser.userId,
      );

      setPartnershipList(p);
      let e = await api.getExpenseListByPartnershipIds(
        p.map((x) => x.partnershipId).join(","),
      );

      setExpenses(e);
      setIsLoading(false);

      api.getVendors().then((v) => {
        setVendors(v.sort((a, b) => a.vendorName.localeCompare(b.vendorName)));
      });
    } catch (err) {
      setIsLoading(false);
    }
  };

  const getPartnershipIds = () => {
    return parseInt(selectedPartnershipId) > 0
      ? selectedPartnershipId
      : partnershipList.map((x) => x.partnershipId).join(",");
  };

  const addNewExpense = () => {
    setExpenseToEdit({ ...newExpense });
    setShowExpenseModal(true);
  };

  return (
    <Fragment>
      <PageTitle heading="Expenses" />
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && (
        <Fragment>
          <Row>
            {partnershipList.length > 0 && (
              <Col md="3">
                <div className="form-group">
                  <Label>Client</Label>
                  <CustomInput
                    type="select"
                    value={selectedPartnershipId}
                    onChange={(e) => setSelectedPartnershipId(e.target.value)}
                  >
                    <option key={0} value={-1}>
                      All Clients
                    </option>
                    {partnershipList.map((p) => {
                      return (
                        <option key={p.partnershipId} value={p.partnershipId}>
                          {p.partnershipName}
                        </option>
                      );
                    })}
                  </CustomInput>
                </div>
              </Col>
            )}
            <Col md="3">
              <div className="form-group">
                <Label>Vendor</Label>
                <CustomInput
                  type="select"
                  id="vendorId"
                  value={selectedVendorId}
                  onChange={(e) => {
                    setSelectedVendorId(parseInt(e.target.value));
                  }}
                >
                  <option value={-1}>All</option>
                  {vendors.map((v) => {
                    return (
                      <option key={v.vendorId} value={v.vendorId}>
                        {v.vendorName}
                      </option>
                    );
                  })}
                </CustomInput>
              </div>
            </Col>
            <Col md="3">
              <div className="form-group">
                <Label>Start Date</Label>
                <DatePicker
                  selected={startDate}
                  onChange={(e) =>
                    setStartDate(moment(e).startOf("day").toDate())
                  }
                  className="form-control"
                />
              </div>
            </Col>
            <Col md="3">
              <div className="form-group">
                <Label>End Date</Label>
                <DatePicker
                  selected={endDate}
                  onChange={(e) => setEndDate(moment(e).endOf("day").toDate())}
                  className="form-control"
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                color="primary"
                onClick={() => {
                  addNewExpense();
                }}
                style={{ marginLeft: "10px" }}
              >
                Create New Expense
              </Button>
            </Col>
          </Row>
          <Row style={{ marginTop: "30px" }}>
            <Col md="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <div className="table-responsive">
                    {expenses.length > 0 && (
                      <BootstrapTable
                        bootstrap4
                        striped
                        bordered={false}
                        keyField="expenseId"
                        data={expenses.filter(
                          (x) =>
                            moment(x.expenseDate).toDate() <= endDate &&
                            moment(x.expenseDate).toDate() >= startDate &&
                            (selectedVendorId == -1 ||
                              x.vendorID == selectedVendorId),
                        )}
                        columns={[
                          {
                            dataField: "expenseName",
                            text: "Expense",
                            sort: true,
                            headerStyle: () => {
                              return { width: "15%" };
                            },
                            formatter: (cellContent, row) => {
                              return (
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e && e.preventDefault();
                                    setExpenseToEdit(row);
                                    setShowExpenseModal(true);
                                  }}
                                >
                                  {cellContent}
                                </a>
                              );
                            },
                          },
                          {
                            dataField: "matterName",
                            text: "Matter",
                            sort: true,
                            headerStyle: () => {
                              return { width: "20%" };
                            },
                          },
                          {
                            dataField: "expenseDate",
                            text: "Date",
                            sort: true,
                            headerStyle: () => {
                              return { width: "15%" };
                            },
                            formatter: (cellContent, row) => {
                              return cellContent == null
                                ? ""
                                : moment(cellContent).format("MM/DD/YYYY");
                            },
                          },
                          {
                            dataField: "expenseAmount",
                            text: "Amount",
                            sort: true,
                            headerStyle: () => {
                              return { width: "20%" };
                            },
                            formatter: (cellContent, row) => {
                              return currencyFormatter("$", cellContent, true);
                            },
                          },
                          {
                            dataField: "invoiceNumber",
                            text: "Invoice",
                            sort: true,
                            headerStyle: () => {
                              return { width: "15%" };
                            },
                            formatter: (cellContent, row) => {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {row.invoiceId > 0 && (
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e && e.preventDefault();
                                        props.history.push(
                                          `/invoice/${row.invoiceId}`,
                                        );
                                      }}
                                    >
                                      {cellContent}
                                    </a>
                                  )}
                                  <span style={{ marginRight: "10px" }}>
                                    {row.invoiceId == 0
                                      ? ""
                                      : row.invoiceOutstandingAmount == 0
                                        ? "Paid"
                                        : row.invoicePaidAmount == 0
                                          ? "Unpaid"
                                          : "Partially Paid"}
                                  </span>
                                </div>
                              );
                            },
                          },
                          {
                            dataField: "notes",
                            text: "Description",
                            sort: true,
                            headerStyle: () => {
                              return { width: "40%" };
                            },
                          },
                        ]}
                        defaultSorted={[
                          {
                            dataField: "expenseDate",
                            order: "asc",
                          },
                        ]}
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Fragment>
      )}
      {expenseToEdit != null && (
        <ExpenseModal
          expenseObj={expenseToEdit}
          showModal={showExpenseModal}
          toggleModal={() => setShowExpenseModal(!showExpenseModal)}
          reload={loadExpenses}
          addAnotherExpense={(exp) => {
            setExpenseToEdit({
              ...newExpense,
              matterId: exp.matterId,
              matterName: exp.matterName,
              expenseDate: exp.expenseDate,
            });
          }}
        />
      )}
    </Fragment>
  );
};

export default ExpenseList;
